import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CBadge,
} from "@coreui/react";
import { format } from "date-fns";
import { formatDateString } from "../../../helpers/general";

interface Props {
  items: PointsHistory[];
}

export default function PointsHistoryTable({ items }: Props) {
  return (
    <CTable responsive>
      <CTableHead>
        <CTableRow>
          <CTableHeaderCell>Date</CTableHeaderCell>
          <CTableHeaderCell>Points</CTableHeaderCell>
          <CTableHeaderCell>Type</CTableHeaderCell>
          <CTableHeaderCell>Référence</CTableHeaderCell>
          <CTableHeaderCell>Description</CTableHeaderCell>
        </CTableRow>
      </CTableHead>

      <CTableBody>
        {items.map((item) => (
          <CTableRow key={item.id}>
            {/* Date */}
            <CTableDataCell className="p-3 text-md">
              {formatDateString(item.createdAt)} -{" "}
              {format(new Date(item.createdAt), "HH:mm")}
            </CTableDataCell>

            {/* Points */}
            <CTableDataCell className="p-3 text-md">
              <span
                className={
                  item.points > 0
                    ? "text-success fw-bold"
                    : "text-danger fw-bold"
                }
              >
                {item.points > 0 ? `+${item.points}` : `-${item.points}`}
              </span>
            </CTableDataCell>

            {/* Type */}
            <CTableDataCell className="p-3 text-md">
              <CBadge
                style={
                  item.source === "RIDE"
                    ? { backgroundColor: "#FFB800" }
                    : { backgroundColor: "#FF7722" }
                }
                className="p-2"
              >
                {item.source}
              </CBadge>
            </CTableDataCell>

            {/* Booking / Reference */}
            <CTableDataCell className="p-3 text-md">
              {item.booking?.title || "-"}
            </CTableDataCell>

            {/* Description */}
            <CTableDataCell className="p-3 text-md">
              {item.description || "-"}
            </CTableDataCell>
          </CTableRow>
        ))}
      </CTableBody>
    </CTable>
  );
}
